exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-header-root {\n  z-index: 1000;\n  position: fixed;\n  width: 100%;\n  border: 1px solid #A3B7C1;\n  background-color: white; }\n", ""]);

// exports
